import { SITE_DESCRIPTION, SITE_NAME } from '../data/site';

function setMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  if (el.content !== value) el.content = value;
}

function applySiteName() {
  if (document.title !== SITE_NAME) document.title = SITE_NAME;
  setMeta('name', 'application-name', SITE_NAME);
  setMeta('name', 'apple-mobile-web-app-title', SITE_NAME);
  setMeta('name', 'description', SITE_DESCRIPTION);
  setMeta('property', 'og:title', SITE_NAME);
  setMeta('property', 'og:site_name', SITE_NAME);
  setMeta('property', 'og:description', SITE_DESCRIPTION);
  setMeta('name', 'twitter:title', SITE_NAME);
}

/** Locks the page title and name metadata to SITE_NAME, restoring it if anything else changes it. */
export function lockSiteName() {
  applySiteName();
  const observer = new MutationObserver(() => {
    if (document.title !== SITE_NAME) applySiteName();
  });
  observer.observe(document.head, { childList: true, subtree: true, characterData: true });
}
